import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// puts the app on the page
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
